export default __webpack_public_path__ + "static/media/office1-after2-768w.d0b8cccc.png";